import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find(): Observable<any> {
    return this._http.get(`${this._apiUrl}/getAllEmailTemplate`);
  }

  get(id: number) {
    return this._http.get(`${this._apiUrl}/getEmailTemplateById/${id}`).pipe(
      map((res: any) => {
        return res.result[0];
      }),
    );
  }

  create(formData: FormData) {
    return this._http.post(`${this._apiUrl}/createEmailTemplate`, formData);
  }

  update(id: number, formData: FormData) {
    return this._http.put(`${this._apiUrl}/updateEmailTemplate/${id}`, formData);
  }

  delete(id: number) {
    return this._http.delete(`${this._apiUrl}/deleteEmailTemplate/${id}`);
  }
}
